import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Brand, Project } from '../../models/dbmodels';
import { BrandState } from './brands.reducer';
import { selectAllBrands, selectBrandById, selectBrandsLoaded } from './brands.selector';

interface BrandColor {
  primary: ColorVariant;
  secondary: ColorVariant;
}

interface ColorVariant {
  main: string;
  tint: string;
  shade: string;
}

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  defaultBrandName = 'firstco';
  private brandColors: { [key: string]: BrandColor } = {
    'ae-air': {
      primary: { main: '#049193', tint: '#1d9c9e', shade: '#048081' },
      secondary: { main: '#225186', tint: '#386292', shade: '#1e4776' },
    },
    'firstco': {
      primary: { main: '#225186', tint: '#386292', shade: '#1e4776' },
      secondary: { main: '#049193', tint: '#1d9c9e', shade: '#048081' },
    },
  };

  constructor(private store: Store<BrandState>) {
  }  // HttpClient is injected via the constructor

  getBrandById(brandId: number): Brand {
    var allBrands: Brand[] = this.getAllBrands();
    return allBrands.find(x => x.BrandId == brandId)
  }

  getAllBrands(): Brand[] {
    let brands: Brand[] = [];
    const brandsLoaded$ = this.store.select(selectBrandsLoaded); // A selector that checks if brands are loaded
    brandsLoaded$.subscribe((loaded) => {
      if (loaded) {
        console.log("Brand State loaded");
        this.store.select(selectAllBrands)
        .subscribe(value => {
          if (loaded) {
            brands = value;
          }

        });
      } else {
        console.log("Brand State loading...");
      }

    });

    return brands;
  }

  setAppTheme(brandCssName: string): void {

    // Select the <ion-app> element
    const appRoot = document.querySelector('ion-app');

    if (!appRoot) {
      console.error('ion-app element not found');
      return;
    }

    // Remove any previously set brand-specific classes
    const brandClasses = Array.from(appRoot.classList).filter(className => className.startsWith('brand-'));
    if (brandClasses.length > 0) {
      brandClasses.forEach(brandClass => appRoot.classList.remove(brandClass));
    }

    // Add the new brand CSS class
    appRoot.classList.add(brandCssName);
  }

  //return this.brandColors[brandName];
  getDefaultBrand(): Brand {

    let brands$ = this.store.select(selectAllBrands);
    let defaulltBrand: Brand = {};
    brands$.subscribe(brands => {
      defaulltBrand = brands.find(x => x.Name.toLocaleLowerCase() == this.defaultBrandName)
    });
    return defaulltBrand;
  }

  setComponentTheme(brandId: number, componentElement: HTMLElement): void {
    const brandsLoaded$ = this.store.select(selectBrandsLoaded); // A selector that checks if brands are loaded

    brandsLoaded$.subscribe((loaded) => {
      if (loaded) {
        // Now that brands are loaded, we can safely select the brand
        const brand$ = this.store.select(selectBrandById(brandId));
        brand$.subscribe(brand => {
          if (brand) {
            const colors = this.brandColors[brand.Name];
            if (!colors) {
              console.warn(`Brand "${brand.Name}" not found. Default colors will be used.`);
              return;
            }
            componentElement.style.setProperty('--ion-color-primary', colors.primary.main);
            componentElement.style.setProperty('--ion-color-primary-tint', colors.primary.main);
            componentElement.style.setProperty('--ion-color-primary-shade', colors.primary.shade);
            componentElement.style.setProperty('--ion-color-secondary', colors.secondary.main);
            componentElement.style.setProperty('--ion-color-secondary-tint', colors.secondary.tint);
            componentElement.style.setProperty('--ion-color-secondary-shade', colors.secondary.main);
          } else {
            console.warn(`Brand with ID "${brandId}" not found.`);
          }
        });
      } else {
        console.warn('Brands are still loading, cannot set the theme yet.');
      }
    });
  }

  setProjectComponentTheme(project: Project, componentElement: HTMLElement) {
    let projectBrandId = project.Brand != null ? project.BrandId : project.Company.DefaultBrandId;

    this.setComponentTheme(projectBrandId, componentElement)
  }

}
